module.exports = __webpack_public_path__ + "img/View_Icon.1bff0123.svg";